/**
 * @generated SignedSource<<f3fcde448d8b45c706456cfde9504422>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type Welcome_organization$fragmentType: FragmentType;
export type Welcome_organization$data = {|
  +name: string,
  +permissions: {|
    +pipelineCreate: ?{|
      +allowed: boolean,
    |},
  |},
  +public: boolean,
  +slug: string,
  +$fragmentType: Welcome_organization$fragmentType,
|};
export type Welcome_organization$key = {
  +$data?: Welcome_organization$data,
  +$fragmentSpreads: Welcome_organization$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Welcome_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "public",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrganizationPermissions",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "pipelineCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowed",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node/*: any*/).hash = "f4a6a28a11b25532d41b0cff83c12cb1";

module.exports = ((node/*: any*/)/*: Fragment<
  Welcome_organization$fragmentType,
  Welcome_organization$data,
>*/);
